import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';
import { CslLocation } from '@shared/ui-service';
import { PositionErrors } from '../../models/position-errors.model';

@Component({
  selector: 'csl-map-wrapper',
  standalone: true,
  imports: [CommonModule, GoogleMap, MapAdvancedMarker],
  templateUrl: './map-wrapper.component.html',
  styleUrl: './map-wrapper.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapWrapperComponent {
  @Input({ required: true }) set location(value: CslLocation | null | PositionErrors) {
    if (typeof value === 'number') {
      this.hasError = value === PositionErrors.PositionUnavailable;
      this._location = null;
      return;
    }

    if (value) {
      this.options = {
        ...this.defaultMapOptions,
        center: { ...value },
      };
    }

    this.hasError = false;
    this._location = value;
  }

  get location(): CslLocation | null {
    return this._location;
  }

  private _location: CslLocation | null = null;

  readonly defaultMapOptions: google.maps.MapOptions = {
    clickableIcons: false,
    disableDefaultUI: true,
    gestureHandling: 'none',
    disableDoubleClickZoom: true,
    fullscreenControl: false,
    keyboardShortcuts: false,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false,
    zoom: 16,
    // mapId: 'DEMO_MAP_ID', // demo MAP_ID for testing purposes
    mapId: 'ddc01734ea931dddbc124f01', // production MAP_ID provided from Google Cloud Console account
    center: { lat: 0, lng: 0 },
  };

  options: google.maps.MapOptions = { ...this.defaultMapOptions };

  hasError = false;
}
